

import Vue from 'vue'
import App from './App'
import router from './router'
import Resource from 'vue-resource'
import config from './config'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(ToastPlugin)


Vue.use(ToastPlugin, {position: 'center'})
Vue.use(Resource);
Vue.config.productionTip = false

Vue.http.interceptors.push(function(request, next) {
var originUrl = request.url;
if(/^\$\$/.test(request.url)){
request.url = config.wechat + request.url.replace(/^\$\$/, "");
}else{
request.url = config.url + request.url;
}
request.headers.set('Accept', 'application/json; charset=utf-8')
next(function(response) {
return response
})
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js